<app-pagination-header
  [label]="label"
  [paging]="paging"
  (pageSizeChange)="pageSizeChange.emit($event)" />

@if (!loading) {
  <app-client-encounter-type-eligibility-list
    [clientEncounterTypeEligibilities]="clientEncounterTypeEligibilities" />
} @else {
  <mat-spinner diameter="30" />
}

<app-pagination [paging]="paging" (pageChange)="pageChange.emit($event)" />
